/* [AO] Dawn 15.4.0 file with custom edits — search '[AO' below.
   Edits: [AO nav] mega menu height cap follows the header while a menu is open (Dawn set it once).
   Built by: Claude (2026-10-27). */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onScroll = this.onScroll.bind(this); // [AO nav] mega menu scroll tracking
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    /* [AO nav] START — replaces Dawn's one-time "return if --header-bottom-position-desktop is set".
       Keep the mega menu height cap matched to where the header is while the panel is open. */
    if (this.mainDetailsToggle.open) {
      this.setHeaderBottom();
      window.addEventListener('scroll', this.onScroll, { passive: true });
    } else {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  /* [AO nav] END */

  /* [AO nav] START — scroll handler; setHeaderBottom() below is Dawn's own code moved into a method */

  onScroll() {
    if (this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;
      if (this.mainDetailsToggle.open) this.setHeaderBottom();
    });
  }
  /* [AO nav] END */

  setHeaderBottom() {
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
